"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCheckboxGroup = exports.StyledCheckboxLabel = exports.StyledCheckbox = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../utils/helpers");

var _commonElements = require("../utils/commonElements");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Copyright 2019 Esri
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// http://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.​


var StyledCheckbox = (0, _styledComponents.default)(_commonElements.baseRadioCheckbox).withConfig({
  displayName: "StyledCheckbox",
  componentId: "sc-1cugyqs-0"
})(["-webkit-appearance:checkbox;margin-right:", ";cursor:pointer;"], function (props) {
  return (0, _helpers.unitCalc)(props.theme.baseline, 4, '/');
});
exports.StyledCheckbox = StyledCheckbox;

var StyledCheckboxLabel = _styledComponents.default.span.withConfig({
  displayName: "StyledCheckboxLabel",
  componentId: "sc-1cugyqs-1"
})(["", ";color:", ";width:auto;margin-right:", ";cursor:pointer;"], (0, _helpers.fontSize)(-1), function (props) {
  return props.theme.palette.darkestGray;
}, function (props) {
  return props.theme.baseline;
});

exports.StyledCheckboxLabel = StyledCheckboxLabel;

var StyledCheckboxGroup = _styledComponents.default.label.withConfig({
  displayName: "StyledCheckboxGroup",
  componentId: "sc-1cugyqs-2"
})(["display:flex;align-items:center;"]);

exports.StyledCheckboxGroup = StyledCheckboxGroup;